import styles from './render-chat-messages.module.scss';
import React from 'react';
import { MessageReferences } from './render-references';
import { ResponseActions } from './response-actions';
import { MessageResources } from './render-resources';
import { useSelector } from 'react-redux';
import { useKnowledgeItems } from 'shared/hooks/knowledge-items.hooks';
import ReactMarkdown from 'react-markdown';
import { useChatConversation } from '../../hooks/use-chat-conversation';
import { ANSWER_STATE, HISTORY_STATE, ROUTES } from 'shared/constants';
import { getWorkspaceById } from 'shared/store/selectors/workspace.selector';
import { isThereOnlyOneWorkspace } from 'shared/store/selectors/workspace.selector';
import { Owners } from 'src/components/common/owners';
import { BrandingLogo } from 'src/components/common/branding-logo';
import { NATIONAL_RECOMMENDATION_BRAND } from 'shared/constants/branding.constants';
import { Link } from 'react-router-dom';

export function RenderAnswer({ message, renderAvatar }) {
  const { lang } = useChatConversation();

  const knowledgeItemId = message?.references?.[0] ? message.references[0]?.knowledgeItemId : null;
  const { data: [knowledgeItem] = [] } = useKnowledgeItems([knowledgeItemId]);
  const workspace = useSelector(getWorkspaceById(knowledgeItem?.workspaceId));
  const isOnlyOneWorkspace = useSelector(isThereOnlyOneWorkspace);

  // Get linked item workspace
  const workspaceIdFromLink = message?.references?.[0]
    ? message?.references[0]?.categoriesInfo[0]?.workspaceId
    : null;
  const workspaceFromLink = useSelector(getWorkspaceById(workspaceIdFromLink));

  const workspaceName = workspace?.name ?? workspaceFromLink?.name ?? '';

  const isResourcesOnly = message.state === ANSWER_STATE.ONLY_RESOURCES_FOUND;
  const isRegenerated = message.historyState === HISTORY_STATE.REGENERATED;

  const isHistoryMessage = !message.id;

  const { showOptimized = false, optimizedQuestion = '' } = message;

  return (
    <div className={styles.message}>
      <div className={styles.answerWrapper}>
        {showOptimized && (
          <div className={styles.optimizedQuestion}>
            <span>{lang.OPTIMIZED_QUESTION}</span>
            <p>{optimizedQuestion}</p>
            <span>{lang.OPTIMIZED_QUESTION_FALLBACK_GUIDELINE}</span>
          </div>
        )}

        <div className={styles.avatarAndContentWrapper}>
          {renderAvatar(false)}

          <div className={styles.content}>
            <div className={styles.botNameTitle}>
              <h4>{lang.BOT_NAME}</h4>
              {isRegenerated && <span>{`(${lang.REGENERATED})`}</span>}
            </div>

            {/* Added as a demo of ASA content */}
            {workspaceName === NATIONAL_RECOMMENDATION_BRAND && (
              <div className={styles.nationalRecommendation}>{lang.NATIONAL_RECOMMENDATION}</div>
            )}
            <BrandingLogo brandName={workspaceName} />
            <ReactMarkdown className={styles.messageContent}>{message.content}</ReactMarkdown>

            <div className={styles.details}>
              {knowledgeItem && !isResourcesOnly && !message.error && (
                <div className={styles.ownerSection}>
                  <span>{`${lang.REASONING_KNOWLEDGE_ITEM}`}</span>
                  <Link
                    className={styles.mainResourceLink}
                    to={ROUTES.KNOWLEDGE_ITEMS.replace(':id', knowledgeItem.id)}>
                    {knowledgeItem.title}
                  </Link>
                  {!isOnlyOneWorkspace && <span>{workspaceName ? ` (${workspaceName})` : ''}</span>}
                  {knowledgeItem.ownerIds && knowledgeItem.ownerIds.length > 0 && (
                    <Owners ownerIds={knowledgeItem.ownerIds} title={lang.VETTED_BY} />
                  )}
                </div>
              )}

              {!message.error && (
                <div className={styles.collapses}>
                  <MessageReferences message={message} />

                  <MessageResources
                    message={message}
                    excludeKnowledgeItemId={!isResourcesOnly ? knowledgeItemId : ''}
                  />

                  {!isHistoryMessage && <ResponseActions message={message} />}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
